import React from "react";
import { EmptyAds } from "../../assets/images";

const EmptyChat: React.FC = () => {
  return (
    <div className="flex flex-col w-full gap-2 items-center mt-[100px]">
      <img src={EmptyAds} alt="" />
      <h1 className="text-[#000] font-Poppins font-normal text-lg">
        You have no inbox yet
      </h1>
    </div>
  );
};

export default EmptyChat;
